"use client";

import React, { useEffect } from "react";

const AboutGondolaModalContent: React.FC = () => {
  return (
    <div className="my-2 flex flex-col gap-2">
      <Item
        content="See your automated points dashboard in seconds"
        // icon="/assets/credit-card-sync/shield-check.png"
        icon="/assets/booking/points.png"
      />
      <Item
        content="Earn an additional 3% cashback on every booking"
        icon="/assets/credit-card-sync/chart-bar.png"
      />
      <Item
        content="Get notified on hotel price drops so you can save"
        icon="/assets/credit-card-sync/clipboard-document-check.png"
      />
    </div>
  );
};

const Item: React.FC<{ content: string; icon: string }> = ({
  content,
  icon,
}) => {
  return (
    <div className="mt-4 flex items-start gap-3">
      <div className="">
        <img src={icon} alt={icon} width={24} height={24} loading="lazy" />
      </div>
      <div className="shrink grow basis-0 text-base font-normal text-foreground">
        {content}
      </div>
    </div>
  );
};

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { DialogProps } from "@/components/ui/dialog";

import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface AboutGondolaModalProps extends DialogProps {
  onClick?: () => void;
}

const AboutGondolaModal: React.FC<AboutGondolaModalProps> = ({
  onClick,
  ...props
}) => {
  const [open, setOpen] = React.useState(props.open);

  useEffect(() => setOpen(props.open), [props.open]);

  return (
    <Dialog open={open} {...props}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Interested in more personalized options?</DialogTitle>
          <DialogDescription>
            Get started with Gondola to unlock curated hotel recommendations
            based on your loyalty points and preferences.
          </DialogDescription>
        </DialogHeader>
        <AboutGondolaModalContent />
        <DialogFooter>
          <Button
            variant="3d-gold"
            className="h-[56px] font-medium"
            onClick={onClick}
          >
            <span className="flex items-center gap-2">
              Get started <ArrowRight className="w-4 lg:w-6" />
            </span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AboutGondolaModal;
